import { api as generatedApi, ErpSyncBatch } from 'gen/rtk-openapi'

const TAG_TYPES = {
  batches: 'Batches',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.batches],
  endpoints: {
    getBatches: {
      providesTags: result =>
        result && result.Items.length > 0
          ? // successful query
            [
              ...result.Items.map((batch: ErpSyncBatch) => ({
                type: TAG_TYPES.batches,
                id: batch.batchNumber,
              })),
              { type: TAG_TYPES.batches, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Batches', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.batches, id: 'LIST' }],
    },
    getBatch: {
      providesTags: (_result, _error, { batchId }) => [{ type: TAG_TYPES.batches, id: batchId }],
    },
  },
})

export const { useGetBatchQuery, useGetBatchesQuery } = api
